<template>




    <v-dialog
      v-model="localDialog"
      max-width="500"
      dark black
    >
      <s-card class="grey darken-3">
        <span class=" d-block headline white--text mt-4 mb-4" :class="[$vuetify.breakpoint.mdAndUp ? 'mb-0 px-3 ' : 'px-5 mb-2']">
          {{ action == null ? '' : action.label }}
        </span>
        <v-simple-table dense class="pa-2">
        <template v-slot:default>
          <tbody>
            <tr>
              <td class="pa-3 font-weight-bold" style="width: 50% !important;">Actie</td>
              <td class="pa-3" style="width: 50% !important;">{{ action == null ? '' : action.label }}</td>
            </tr>
            <tr>
              <td class="pa-3 font-weight-bold" style="width: 50% !important;">Prioriteit</td>
              <td class="pa-3" style="width: 50% !important;">{{ action == null ? '' : action.priority }}</td>
            </tr>
            <tr>
              <td class="pa-3 font-weight-bold" style="width: 50% !important;">Status</td>
              <td class="pa-3" style="width: 50% !important;">{{ action == null ? '' : action.state }}</td>
            </tr>
            <tr>
              <td class="pa-3 font-weight-bold" style="width: 50% !important;">Datum</td>
              <td class="pa-3" style="width: 50% !important;">{{ action == null ? '' : toDateTime(action.date) }}</td>
            </tr>
            <tr>
              <td class="pa-3 font-weight-bold" style="width: 50% !important;">Laatst geupdate</td>
              <td class="pa-3" style="width: 50% !important;">{{ action == null ? '' : toDateTime(action.date) }}</td>
            </tr>
            <tr>
              <td class="pa-3 font-weight-bold" style="width: 50% !important;">EAN</td>
              <td class="pa-3" style="width: 50% !important;">{{ action == null ? '' : action.ean }}</td>
            </tr>
            <tr>
              <td class="pa-3 font-weight-bold" style="width: 50% !important;">Energietype</td>
              <td class="pa-3" style="width: 50% !important;">{{ action == null ? '' : action.type }}</td>
            </tr>
            <tr>
              <td class="pa-3 font-weight-bold" style="width: 50% !important;">Categorie</td>
              <td class="pa-3" style="width: 50% !important;">{{ action == null ? '' : action.category }}</td>
            </tr>
            <tr>
              <td class="pa-3 font-weight-bold" style="width: 50% !important;">Address</td>
              <td class="pa-3" style="width: 50% !important;">{{ action == null ? '' : action.postal }} {{ action == null ? '' : action.number }} {{ action == null ? '' : action.addition }}</td>
            </tr>

          </tbody>
        </template>
        </v-simple-table>
        <v-card-actions class="pa-3 grey darken-2">
        <v-spacer></v-spacer>

          <v-btn 
            @click="markAsInProgress" v-if="action != null && action.state == 'open'">
            Markeer als in behandeling
          </v-btn>

          <v-btn
            color="primary" to="" class="text-none text-none"
            v-html="'Sluiten'" @click="localDialog=false;"
          ></v-btn>

        </v-card-actions>
      </s-card>
    </v-dialog>













</template>
<script>
export default {
    props:['action', 'dialog'],
  data() {
      return {};
  },
  methods:
  {
    markAsInProgress()
    {
        let data = {request: {state:2}, action:this.action};
        this.$store.dispatch('updateAction', data).then
        ((data) => {
          this.$emit('actionUpdated', data.data); 
      });
    }
  },
  computed:
  {
    localDialog:
    {
        get: function(){ return this.dialog },
        set: function(value){ this.$emit('update:dialog', value) }
    }
  }
};
</script>